export default [{
    title: "Mantenimiento",
    fontIcon: "ThermometerIcon",
    resource: "Mantenimiento",
    action: "ver-mantenimiento",
    children: [
        {
            title: "Termocuplas",
            // icon: "BarChart2Icon",
            icon: "ThermometerIcon",
            resource: "Mantenimiento",
            action: "ver-mantenimiento-dashboard",
            // route: "mantenimiento-dashboard",
            children: [
                {
                    title: "Dashboard",
                    icon: "BarChart2Icon",
                    resource: "Mantenimiento",
                    action: "ver-mantenimiento-dashboard",
                    route: "mantenimiento-dashboard",
                },
                {
                    title: "Reportes",
                    icon: "ClipboardIcon",
                    resource: "Mantenimiento",
                    action: "ver-mantenimiento-reportes",
                    route: "mantenimiento-reportes",
                },
            ]
        },
        // {
        //     title: "Dashboard",
        //     icon: "BarChart2Icon",
        //     resource: "Mantenimiento",
        //     action: "ver-mantenimiento-dashboard",
        //     route: "mantenimiento-dashboard",
        // },
        // {
        //     title: "Reportes",
        //     icon: "ClipboardIcon",
        //     resource: "Mantenimiento",
        //     action: "ver-mantenimiento-reportes",
        //     route: "mantenimiento-reportes",
        // },
        // {
        //     title: "Configuracion",
        //     icon: "SettingsIcon",
        //     resource: "Mantenimiento",
        //     action: "ver-mantenimiento-reportes"
        // },
        /* {
            title: "Mantenimiento",
            icon: "EditIcon",
            resource: "Mantenimiento",
            action: "ver-Mantenimiento-produccion-mantenimiento"
        },
        {
            title: "Transacciones",
            fontIcon: "exchange-alt",
            resource: "Mantenimiento",
            action: "ver-Mantenimiento-produccion-transacciones",
        },
        {
            title: "Informes",
            fontIcon: "file-prescription",
            resource: "Mantenimiento",
            action: "ver-Mantenimiento-produccion-informes",
        } */
    ]
},]
